let theCurrentFocusedId = "";

export const setCurrentFocusedId = (id: string): void => {
  theCurrentFocusedId = id;
};

export const getCurrentFocusedId = (): string => theCurrentFocusedId;
